module.exports = __webpack_public_path__ + "img/g10.80a5b5b6.png";